import { css } from 'styled-components';
import { media } from './constants';

// [Style] Tweak here to change text appearance
// (some font-weights are in the Components' style themselves)
export const big = css`
  font-weight: 600;
  font-size: 4.6rem;

  @media (min-width: ${media.tabletPortrait}) {
    font-size: 8.4rem;
  }

  @media (min-width: ${media.tabletLandscape}) {
    font-size: 11.4rem;
  }

  @media (min-width: ${media.desktop}) {
    font-size: 13rem;
  }
`;

export const small = css`
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 2.4rem;
`;

export const h1 = css`
  font-weight: 600;
  font-size: 4rem;
  line-height: 4.6rem;

  @media (min-width: ${media.phone}) {
    font-size: 5.1rem;
    line-height: 6rem;
  }

  @media (min-width: ${media.tabletPortrait}) {
    font-size: 5.8rem;
    line-height: 7.2rem;
  }

  @media (min-width: ${media.tabletLandscape}) {
    font-size: 6.8rem;
    line-height: 9rem;
  }

  @media (min-width: ${media.desktop}) {
    font-size: 6.8rem;
    line-height: 9rem;
  }

  @media (min-width: ${media.bigDesktop}) {
    font-size: 7.8rem;
    line-height: 10rem;
  }
`;

export const h2 = css`
  font-weight: 600;
  font-size: 3rem;
  line-height: 3.9rem;

  @media (min-width: ${media.tabletLandscape}) {
    font-size: 3.4rem;
    line-height: 4.5rem;
  }
`;

export const text = css`
  font-size: 2.2rem;
  line-height: 2.9rem;
`;
